import React from 'react';
import { useLocation } from 'react-router-dom';
import loaderSvg from 'assets/images/loader.svg';

interface PageTransitionLoaderProps {
  minShowMs?: number;
  durationMs?: number;
  enabled?: boolean;
}
 
const PageTransitionLoader: React.FC<PageTransitionLoaderProps> = ({
  minShowMs = 350,
  durationMs = 450,
  enabled = true,
}) => {
  const location = useLocation();
  const [visible, setVisible] = React.useState(false);
  const hideTimeoutRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (!enabled) return;
 
    setVisible(true);
 
    if (hideTimeoutRef.current) {
      window.clearTimeout(hideTimeoutRef.current);
    }
    hideTimeoutRef.current = window.setTimeout(() => setVisible(false), Math.max(minShowMs, 120));

    return () => {
      if (hideTimeoutRef.current) {
        window.clearTimeout(hideTimeoutRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!enabled) return null;

  return (
    <div
      aria-hidden={!visible}
      className={`pointer-events-none fixed inset-0 z-40 flex items-center justify-center transition-opacity duration-${durationMs} ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="relative rounded-2xl border border-white/30 bg-white/60 backdrop-blur-xl shadow-2xl px-8 py-6">
        <div className="flex items-center gap-4">
          <img src={loaderSvg} alt="Loading" className="w-10 h-10 animate-spin-smooth" />
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-secondary-900">Loading</span>
            <span className="text-xs text-secondary-600">Just a moment…</span>
          </div>
        </div>
        <div className="absolute -inset-0.5 -z-10 rounded-2xl bg-gradient-to-r from-primary-500/20 to-teal-400/20 blur-xl" />
      </div>
    </div>
  );
};

export default PageTransitionLoader;


